import { useEffect, useState } from 'react'

const useToggleStylesheet = (isDark: boolean) => {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    setIsLoaded(false)
    Array.from(document.getElementsByClassName('theme-stylesheet')).forEach(
      (link) => link.remove()
    )
    const link = document.createElement('link')
    link.href = `${process.env.PUBLIC_URL}/css/theme.min.css`
    link.type = 'text/css'
    link.rel = 'stylesheet'
    link.className = 'theme-stylesheet'

    const userLink = document.createElement('link')
    userLink.href = `${process.env.PUBLIC_URL}/css/user.min.css`
    userLink.type = 'text/css'
    userLink.rel = 'stylesheet'
    userLink.className = 'theme-stylesheet'

    link.onload = () => {
      setIsLoaded(true)
    }

    document.getElementsByTagName('head')[0].appendChild(link)
    document.getElementsByTagName('head')[0].appendChild(userLink)
  }, [])

  useEffect(() => {
    document.documentElement.setAttribute(
      'data-bs-theme',
      isDark ? 'dark' : 'light'
    )
  }, [isDark])

  return { isLoaded }
}

export default useToggleStylesheet
